import { z } from "zod";

/**
 * Zod schema for NavLink.
 */
export const navLinkSchema = z.object({
  label: z.string().min(1, "Label is required"),
  href: z.string().min(1, "Href is required"),
});

/**
 * Zod schema for NavigationConfig.
 */
export const navigationConfigSchema = z.object({
  links: z.array(navLinkSchema),
  primaryCta: navLinkSchema.optional(),
});
